/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_2_HInputs */

const en_privacy_2_h = /** @type {(inputs: Privacy_2_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How we use it`)
};

const id_privacy_2_h = /** @type {(inputs: Privacy_2_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk apa kami memakainya`)
};

/**
* | output |
* | --- |
* | "How we use it" |
*
* @param {Privacy_2_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_2_h = /** @type {((inputs?: Privacy_2_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_2_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_2_h(inputs)
	return en_privacy_2_h(inputs)
});